import React, { useState } from 'react'

// hooks
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'

// components
import AvisoZonajobs from './aviso-zonajobs'
import AvisoFinalizado from './aviso-finalizado'
import EstadoDefault from './estado-default'
import EstadoDefaultV2 from './estado-default-v2'
import EstadoEspera from './estado-espera'
import EstadoPostulado from './estado-postulado'

// mixins
import { PostularBarComponentWrapper } from './mixins'

// constants
import features from '../../../../../../constants/features-per-country'
import { SITE_ID } from '../../../../../../constants'

const searchAvisosV2Enabled = features[SITE_ID || 'BMAR'].searchAvisosV2.enabled

const Component = ({
  aviso,
  avisoFinalizado,
  postulacionState,
  postPostulacion,
  applicantEmail,
  redirect,
  handleActivateMail,
  isLoading,
  urlMaker,
  productoLookAndFeel,
  actualizarSalario,
  setActualizarSalario,
  salarioBrutoPretendido,
  setSalarioPretendido,
  salarioRequerido,
  handlePostularme,
  setVisibleModalPreguntasPendientes,
  showPreguntasPendientes,
  postulacionRapida,
}) => {
  const { isMobile, isTabletPortrait } = useWindowSize()

  const [visibleModal, setVisibleModal] = useState(avisoFinalizado ? 'modal-avisos-sugeridos' : '')
  const hideModal = () => setVisibleModal('')

  /*
   * Condicional para mostrar el component salario pretendido
   */
  const showComponentSalarioPretendido = features[SITE_ID || 'BMAR'].fichaAviso?.components?.salarioPretendido
  const showCalculadoraSalario = features[SITE_ID || 'BMAR'].fichaAviso?.calculadoraSalario?.enabled

  const objectProps = {
    aviso,
    isLoading,
    isMobile,
    isTabletPortrait,
    productoLookAndFeel,
    actualizarSalario,
    setActualizarSalario,
    salarioBrutoPretendido,
    setSalarioPretendido,
    salarioRequerido,
    handlePostularme,
    showComponentSalarioPretendido,
    postulacionRapida,
  }

  /**
   * Se imprime el componente de PostularBar dependiendo el estado de postulación correspondiente ó si el aviso es de Zonajobs
   */
  const showPostularBarComponent = () => {
    if (aviso?.origenAviso === 'ZONAJOBS') {
      return <AvisoZonajobs id={aviso.id} />
    }

    if (!avisoFinalizado && postulacionState?.estado === 'ESPERA') {
      return (
        <EstadoEspera
          postulacion={postulacionState}
          emailApplicant={applicantEmail}
          redirect={redirect}
          handleActivateMail={handleActivateMail}
          isLoading={isLoading}
        />
      )
    }

    if (avisoFinalizado && postulacionState?.estado !== 'REALIZADA') {
      return (
        <AvisoFinalizado
          subarea={searchAvisosV2Enabled ? aviso.subArea.idSemantico : aviso.subArea.stringId}
          estado={aviso.estado}
          visibleModal={visibleModal}
          hideModal={hideModal}
          urlMaker={urlMaker}
        />
      )
    }

    if (postulacionState?.estado === 'REALIZADA' || postPostulacion?.estado === 'REALIZADA') {
      return (
        <EstadoPostulado
          avisoState={aviso.estado}
          postulacionState={postulacionState}
          postPostulacion={postPostulacion}
          setVisibleModalPreguntasPendientes={setVisibleModalPreguntasPendientes}
          showPreguntasPendientes={showPreguntasPendientes}
        />
      )
    }

    /**
     * Si no cuenta con ningún estado correspondiente, se muestra el Estado por default
     */
    const propsToChildren = { ...objectProps }
    return showCalculadoraSalario ? <EstadoDefaultV2 {...propsToChildren} /> : <EstadoDefault {...propsToChildren} />
  }

  return <PostularBarComponentWrapper>{showPostularBarComponent()}</PostularBarComponentWrapper>
}

export default Component
